
export interface NavLinkItem {
    to: string;
    label: string;
    type?: 'route' | 'hash';
    exact?: boolean;
    hash?: string;
}
export const navLinks: NavLinkItem[] = [
    {to: '/', label: 'Home', type: 'route', exact: true},
    {to: '/#amaProsList', label: 'Meet the Pros', type: 'hash', hash: '#amaProsList'},
    {to: '/videos', label: 'Videos', type: 'route'},
    { to: '/interviews', label: 'Interviews', type: 'route' },
    {to: '/#about', label: 'About', type: 'hash', hash: '#about'},
];